import React from 'react'
import Card from './styled-components/Card'
import HeaderText from './styled-components/HeaderText'
import HeaderTextSmall from './styled-components/HeaderTextSmall'
import { AnovaLogoSmall } from './AnovaLogo'
import TextColumn from './styled-components/TextColumn'
import { TermsOfServiceAndPrivacyPolicy } from './TermsOfServiceAndPrivacyPolicy'
import { analyticsPage } from '../analytics'

const PasswordResetFailure = () => {
  analyticsPage('ALI Password Reset - Failure')

  return (
    <Card data-password-reset-failed>
      <div>
        <AnovaLogoSmall />
      </div>

      <TextColumn>
        <HeaderText>Try resetting your password<br />again</HeaderText>
        <HeaderTextSmall>The link to reset your password<br />expired or has already been used.</HeaderTextSmall>
      </TextColumn>

      <TermsOfServiceAndPrivacyPolicy />
    </Card>
  )
}

export default PasswordResetFailure
